export default __webpack_public_path__ + "static/building-e634a678728a407c5174ca044e96d33d.png";